module.exports = __webpack_public_path__ + "img/302.54772a3c.png";